import React from "react";
import BulkAdjustmentModal from "./BulkAdjustmentModal";

const BulkDeductionModal = (props) => <BulkAdjustmentModal kind="deduction" {...props} />;

export default BulkDeductionModal;
